import React from "react";
import { Accordion, Box, Text, List } from "@chakra-ui/react";
import { AUDIT_BUNDLES_CONSTANTS } from "./constants";

const AuditBundles = () => {
  const { intro, users } = AUDIT_BUNDLES_CONSTANTS;
  return (
    <Box mb={2} w="full">
      <Accordion.Root mb={8}>
        <Accordion.Item value="audit-bundles" borderRadius="md" border="none">
          <Accordion.ItemTrigger p={2} w="fit-content" bg="gray.100">
            <Box fontWeight="bold" fontSize="md" borderRadius="md" color="text.100">
              *See More About Our Audit Bundles
            </Box>
            <Accordion.ItemIndicator />
          </Accordion.ItemTrigger>
          <Accordion.ItemContent py={3}>
            <Text fontSize="md" color="text.100" fontWeight={600} mb={2}>
              {intro.heading}
            </Text>
            <Text fontSize="md" color="text.100" mb={4}>
              {intro.desc}
            </Text>
            <Text fontSize="md" color="text.100" fontWeight={600} mb={2}>
              {users.heading}
            </Text>
            <List.Root variant="plain" gap={1} mb={2}>
              {users.list.map((item, index) => (
                <List.Item key={index} fontSize="md" color="text.100">
                  <List.Indicator>•</List.Indicator>
                  {item}
                </List.Item>
              ))}
            </List.Root>
          </Accordion.ItemContent>
        </Accordion.Item>
      </Accordion.Root>
    </Box>
  );
};

export default AuditBundles;
